var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 19.13,
    viewBox: "0 0 34 19.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .mobile-footer-menu-line-cls-1{fill:none;stroke:currentColor;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7752",
    transform: "translate(-325 -1748.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_17",
    d: "M0 10L9 0",
    className: "mobile-footer-menu-line-cls-1",
    transform: "translate(328.5 1753.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    d: "M0 10.63L8.592 0",
    className: "mobile-footer-menu-line-cls-1",
    transform: "translate(346.908 1751.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    d: "M0 0L9.583 8.375",
    className: "mobile-footer-menu-line-cls-1",
    transform: "translate(337.917 1753.564)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_611",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "currentColor",
    transform: "translate(325 1760.439)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_612",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "currentColor",
    transform: "translate(334 1750.439)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_614",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "currentColor",
    transform: "translate(352 1748.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_613",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "currentColor",
    transform: "translate(344 1758.439)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.8199e1ea.svg";
export { ForwardRef as ReactComponent };